import { useQuery } from '@tanstack/react-query';
import type {
  AdminPaymentDetail,
  AdminPaymentWebhookLogEntry,
} from '@/lib/api-admin/types';
import { apiClient } from '@/lib/apiClient';

export const paymentQueryKey = (paymentId: string) =>
  ['admin', 'payment', paymentId] as const;

export const usePaymentQuery = (paymentId: string | undefined) =>
  useQuery<AdminPaymentDetail>({
    queryKey: paymentQueryKey(paymentId ?? ''),
    enabled: Boolean(paymentId),
    queryFn: async () => {
      const [data] = await apiClient.request('get', '/api/admin/v1/payments/{paymentId}', {
        params: { path: { paymentId: paymentId as string } },
      });
      return data as AdminPaymentDetail;
    },
  });

export const paymentWebhooksQueryKey = (paymentId: string) =>
  ['admin', 'payment', paymentId, 'webhooks'] as const;

export const usePaymentWebhooksQuery = (paymentId: string | undefined) =>
  useQuery<ReadonlyArray<AdminPaymentWebhookLogEntry>>({
    queryKey: paymentWebhooksQueryKey(paymentId ?? ''),
    enabled: Boolean(paymentId),
    queryFn: async () => {
      const [data] = await apiClient.request(
        'get',
        '/api/admin/v1/payments/{paymentId}/webhooks',
        { params: { path: { paymentId: paymentId as string } } },
      );
      const payload = data as { items: AdminPaymentWebhookLogEntry[] };
      return payload.items;
    },
  });
